import { List } from "@mui/material";
import CustomMenu from "./CustomMenu";

const AppMenu = (props: any) => {
  return (
    <>
      <List component="div" disablePadding>
        <CustomMenu />
      </List>
      {/* 
      <Menu {...props} hasDashboard={true} /> */}
    </>
  );
};

export default AppMenu;
